import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { GlobalDataService } from '../services/global-data.service';
import { EmitterService } from '../services/emitter.service';
@Component({
    selector: 'app-header',
    templateUrl: '../views/header.component.html',
    styleUrls: ['../css/header.component.css']
})
export class HeaderComponent implements OnInit {

   //public usrobj = JSON.parse(localStorage.getItem("user"));
   public usrobj = JSON.parse(sessionStorage.getItem("user"));
   public username :any;
   public roleusrobj:any;
   public current_url='';
   public showAdmin:boolean = false;
   public showSuperUser:boolean = false;
  public userId: string;

   public link :string ='/leads';
    constructor(public _dataService: GlobalDataService, public _router: Router,private _emitterService: EmitterService,) {

    }

    ngOnInit() {
    if(sessionStorage.getItem('roleId')==="SYSADM"){
       this.showAdmin = true;
    }
      if(sessionStorage.getItem('roleId')==="SUSER"){
        this.showAdmin = true;
        this.showSuperUser = true;
      }
     this.current_url= this._router.url;
      this.userId = sessionStorage.getItem('userId');
     this.UserPrivileges();
        if (this.usrobj != null)
        this.username =this.usrobj.lastName
    }
     /**
     * @author Ciocan Vlad
     * @uses   User logout
     */
    logout() {
       //var uuid = localStorage.getItem("uuid")
       const uuid = sessionStorage.getItem("uuid");
       this._dataService.logout({"userUUID" :uuid}, (res) => {
           this._dataService.redirectUrl = "";
          if(res.statusCode==200) {
             localStorage.clear();
             sessionStorage.clear();
             this._router.navigate(['login']);
          } else {
           /* failed need to discuss */
           localStorage.clear();
           sessionStorage.clear();
           this._emitterService.setloadHeader(false);
           this._router.navigate(['login']);
          }
        })
    }
    /**
     * @author Ciocan Vlad
     * @uses   User privileges are defined by the role
     */
    UserPrivileges() {
      if (this.usrobj != null){
            this.roleusrobj = this.usrobj.roleId;
        }

    }
    checkRole(){
        if (this.roleusrobj.code == "ADHVDR"){

            this._router.navigate(['/leads/adhoc']);
        }

        }

    makeUnauth(){
        if (this.roleusrobj.code == "ADHVDR"){
            this._router.navigate(['unauth']);
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/header.component.ts